import { memo } from 'react';

import UserFilledIconSVG from '@/assets/user-filled-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IUserFilledIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={UserFilledIconSVG} {...props} />
);

export const UserFilledIcon = memo(IUserFilledIcon) as typeof IUserFilledIcon;
